var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvRe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.45,97.66a24.67,24.67,0,0,0-10-4.73A21.2,21.2,0,0,1,10.16,72.32V22A21.18,21.18,0,0,1,31.34.82H81.66A21.18,21.18,0,0,1,102.84,22V72.32A21.2,21.2,0,0,1,86.51,92.93a24.67,24.67,0,0,0-10,4.73L60.46,110.77a6.27,6.27,0,0,1-7.92,0Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.51,10.2H81.66A11.8,11.8,0,0,1,93.46,22V72.32a11.8,11.8,0,0,1-11.8,11.8H31.34a11.8,11.8,0,0,1-11.8-11.8V22.17A12,12,0,0,1,31.51,10.2Z",
    fill: "url(#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "evre_logo",
    "data-name": "evre logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6908",
    "data-name": "Path 6908",
    d: "M56.82,41.77a3.07,3.07,0,0,1,.07-.6,1.15,1.15,0,0,1,1-.9,2.2,2.2,0,0,1,.57-.05H63a8.06,8.06,0,0,1,1.2.08,3.76,3.76,0,0,1,1.38.43,3.25,3.25,0,0,1,1.47,1.63,3.58,3.58,0,0,1,.25,1.37,4,4,0,0,1-.2,1.33,2.78,2.78,0,0,1-1,1.38,4.92,4.92,0,0,1-1.6.76l-.4.1a.62.62,0,0,0,.17.11,5,5,0,0,1,1.07.92,11.8,11.8,0,0,1,1.54,2.23,8.16,8.16,0,0,1,.6,1.35,2,2,0,0,1,.09.35.66.66,0,0,1-.06.34,1.14,1.14,0,0,1-.94.73,1.43,1.43,0,0,1-.74,0,1.07,1.07,0,0,1-.37-.22,2.79,2.79,0,0,1-.5-.58c-.6-1-1.17-1.94-1.77-2.91a6.32,6.32,0,0,0-.95-1.29,2.24,2.24,0,0,0-1.37-.65c-.44-.05-.88,0-1.32,0q-.1,0-.09.09v4.09a2.27,2.27,0,0,1-.13.77,1.14,1.14,0,0,1-.94.77,1.42,1.42,0,0,1-.76-.07,1.13,1.13,0,0,1-.7-.8,2.5,2.5,0,0,1-.09-.66s0-.09,0-.14V41.91S56.86,41.81,56.82,41.77ZM59.45,44V45.6c0,.13,0,.13.12.13.9,0,1.8,0,2.69,0a6,6,0,0,0,.84-.09,2.31,2.31,0,0,0,1-.38,1.37,1.37,0,0,0,.52-.77,2.41,2.41,0,0,0,.05-.71,1.3,1.3,0,0,0-.11-.51,1.64,1.64,0,0,0-1.35-1,8.92,8.92,0,0,0-1.37-.08h-2.3c-.07,0-.09,0-.09.09v.1Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6909",
    "data-name": "Path 6909",
    d: "M69.79,46.68V41.79a2.45,2.45,0,0,1,.11-.71,1.08,1.08,0,0,1,.81-.77,2.37,2.37,0,0,1,.65-.09H78.3a1.65,1.65,0,0,1,.58.1.87.87,0,0,1,.61.74,1.11,1.11,0,0,1,0,.48.9.9,0,0,1-.59.61,1.52,1.52,0,0,1-.56.08H72.55c-.14,0-.14,0-.14.14V45.3c0,.07,0,.11.09.1h5.32a1.77,1.77,0,0,1,.56.09.87.87,0,0,1,.63.84,1.12,1.12,0,0,1-.11.54.92.92,0,0,1-.48.41,1.81,1.81,0,0,1-.61.1H72.64c-.26,0-.22,0-.22.23v3.24c0,.21,0,.19.19.19h5.87a1.75,1.75,0,0,1,.64.1,1,1,0,0,1,.61.86,1.14,1.14,0,0,1-.13.63,1.08,1.08,0,0,1-.8.47,4.61,4.61,0,0,1-.64,0H71.44a2.43,2.43,0,0,1-.6,0,1.14,1.14,0,0,1-1-1,2.78,2.78,0,0,1-.06-.58Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6910",
    "data-name": "Path 6910",
    d: "M32.44,46.68V41.79a2.36,2.36,0,0,1,.07-.65,1.14,1.14,0,0,1,1-.87,2.39,2.39,0,0,1,.59-.05h6.88a1.8,1.8,0,0,1,.46.05,1,1,0,0,1,.31,1.78,1.29,1.29,0,0,1-.57.16h-6c-.12,0-.12,0-.12.13v2.94c0,.12,0,.12.13.12h5.3a1.76,1.76,0,0,1,.46.06.87.87,0,0,1,.67.62A1,1,0,0,1,41,47.31a1,1,0,0,1-.24,0,1.94,1.94,0,0,1-.48,0h-5.1c-.2,0-.18,0-.18.18v3.35c0,.11,0,.11.12.12h6a1.55,1.55,0,0,1,.73.15.92.92,0,0,1,.49.69,1.1,1.1,0,0,1-.06.62.89.89,0,0,1-.61.54,1.41,1.41,0,0,1-.5.07H34a1.88,1.88,0,0,1-.77-.14,1,1,0,0,1-.64-.64,2,2,0,0,1-.11-.73V46.68Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6911",
    "data-name": "Path 6911",
    d: "M49.27,50.32c.06,0,0-.08.07-.12l1-3c.44-1.33.89-2.66,1.33-4,.23-.66.45-1.33.68-2a3.94,3.94,0,0,1,.18-.48,1.09,1.09,0,0,1,.77-.7,1.25,1.25,0,0,1,1.49.77,1.26,1.26,0,0,1,.05.67,4.92,4.92,0,0,1-.26.85c-.21.59-.43,1.19-.65,1.78l-.79,2.11-.63,1.71-.88,2.35-.48,1.33a3.9,3.9,0,0,1-.51,1,1.63,1.63,0,0,1-1.16.69,2.11,2.11,0,0,1-.83,0,1.58,1.58,0,0,1-1-.75,4.77,4.77,0,0,1-.43-1l-1.13-3.09c-.29-.8-.58-1.6-.88-2.39l-1.05-2.85c-.15-.42-.3-.83-.43-1.25a2.65,2.65,0,0,1-.17-.8.82.82,0,0,1,.06-.34,1.24,1.24,0,0,1,1-.84,1.75,1.75,0,0,1,.56,0,1,1,0,0,1,.72.57,8.54,8.54,0,0,1,.42,1L47.47,45l.81,2.4L49.15,50Z",
    fill: "#a2eaa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6912",
    "data-name": "Path 6912",
    d: "M56.82,41.77s0,.09,0,.14v9.74c0,.05,0,.1,0,.14a.16.16,0,0,1,0-.13V41.91S56.78,41.81,56.82,41.77Z",
    fill: "#a2eaa0"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvRe);
export default __webpack_public_path__ + "static/media/EVRe.4b4258641e40771e4bf2114bf24b80be.svg";
export { ForwardRef as ReactComponent };